import React from 'react';
import { Navigate } from 'react-router-dom';

export const ProfilePage: React.FC = () => <Navigate to="/dashboard" replace />;
